import Search from './search';

const componentsSearch = document.querySelector('#component-search');

class ComponentsSearch extends Search {
    constructor(container) {
        super(container)

        if (!componentsSearch) return

        this.buttons = this.container.querySelectorAll('.nav-buttons button');
        this.group = this.container.querySelector('.nav-buttons button');
        
        this.groupTitle = this.group.textContent.toLowerCase();

        this.init();
    }

    inputHandler() {
        this.field.addEventListener('input', (e) => {
            const value = e.target.value.toLowerCase();

            this.hideAllElements();
            this.disactivateNavItem();

            if (!value.length) {
                this.activateFeaturesGroup();
                this.activateNavItem();
            } else {
                this.search(value);
            }
        })
    }

    activateFeaturesGroup() {
        this.items.forEach(item => {
            const data = item.dataset.key;

            if (data == this.groupTitle) this.show(item);
        })
    }

    activateNavItem() {
        this.buttons.forEach(btn => {
            const value = btn.textContent.toLowerCase();

            if (value == this.groupTitle) {
                btn.classList.add('active');
            }
        })
    }

    disactivateNavItem() {
        this.buttons.forEach(btn => btn.classList.remove('active'));
    }
}

export default ComponentsSearch;
